import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/whatsapp";
import { trackWhatsAppClick } from "@/lib/analytics";
import { FLOATING } from "@/constants/testIds";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={waLink("Olá, gostaria de fazer um pedido de coroa de flores.")}
      target="_blank" rel="noreferrer"
      data-testid={FLOATING.whatsapp}
      aria-label="Falar pelo WhatsApp"
      onClick={() => trackWhatsAppClick("floating_button")}
      className="hidden md:inline-flex fixed bottom-6 right-6 z-40 items-center gap-2 bg-[#25D366] hover:bg-[#1FB855] text-white font-medium px-5 h-14 rounded-full shadow-[0_15px_40px_-10px_rgba(37,211,102,0.6)] transition-all duration-300 hover:-translate-y-1"
    >
      <MessageCircle className="h-5 w-5" strokeWidth={2} />
      <span className="hidden sm:inline text-sm">Pedir pelo WhatsApp</span>
    </a>
  );
};
